module.exports = __webpack_public_path__ + "static/media/show.887a900c.svg";